import { Radio } from "antd";
import classNames from "classnames";
import { useState } from "react";
import Label from "../../Label";

const Pill = ({
  errors,
  touched,
  label,
  icon,
  iconLabel,
  onChange,
  values = [],
  value,
  required,
  subLabel,
  size,
  row = true,
  ...rest
}) => {
  const [checkedValue, setCheckedValue] = useState(value);
  const onSelect = (e) => {
    setCheckedValue(e.target.value);
    onChange(e.target.value);
  };
  return (
    <div
      className={classNames("acoris__radio acoris__radio--pill", size, {
        "acoris__radio--error": touched && errors,
      })}
    >
      <Label label={label} icon={iconLabel} required={required} />
      <div className="acoris__radio--field">
        <Radio.Group
          onChange={onSelect}
          value={checkedValue}
          defaultValue={value}
          {...rest}
        >
          {values.map(({ label, icon: optionIcon, value: _value }) => (
            <Radio
              key={`radio.${_value}`}
              value={_value}
              className={classNames({ checked: _value === checkedValue })}
            >
              <div className="acoris__radio--content">
                {typeof optionIcon === "function"
                  ? optionIcon(_value === checkedValue)
                  : optionIcon}
                <span className="acoris__radio--label">{label}</span>
              </div>
            </Radio>
          ))}
        </Radio.Group>
        {touched && errors && <p className="input--errors">{errors}</p>}
      </div>
    </div>
  );
};

export default Pill;
